import {
  useWSModal,
  WSActions,
  WSAlert,
  WSDivider,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";

export interface CardSuspendedProps {
  cardId: string;
  cardName: string;
  onClose: () => void;
}

const CardReactivated: React.FC<CardSuspendedProps> = ({
  cardId,
  cardName,
  onClose
}) => {
  return (
    <WSList gap="L">
      <WSAlert theme="success">Your {cardName} was reactivated</WSAlert>
      <WSInfoBox>
        The card has been successfully reactivated and is now ready for use.
      </WSInfoBox>
      <WSDivider />
      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Continue",
            onClick: async () => {
              onClose();
            },
            kind: "Primary"
          }
        ]}
      ></WSActions>
    </WSList>
  );
};

export function useCardReactivatedModal() {
  return useWSModal(CardReactivated, {
    title: "Card reactivated",
    size: "S"
  });
}
